export default __webpack_public_path__ + "4b40285f71ed297aeb6050a744a67056.svg";